package one.healthium.insights.ui.components.items

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.util.fastForEachIndexed
import loco.MEAL_PLAN_LOG_FOOD_BUTTON
import one.healthium.insights.domain.models.ActionModel
import one.healthium.insights.domain.models.ContentEntry
import one.healthium.ui.compose.components.AppButton
import one.healthium.ui.compose.components.AppButtonDefaults
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.gray_2
import org.jetbrains.compose.resources.stringResource

@Composable
internal fun ContentDay(
    modifier: Modifier = Modifier,
    item: ContentEntry.DayEntry,
    onActionClicked: (ActionModel) -> Unit,
) {
    Column(
        modifier = modifier
            .fillMaxWidth()
            .padding(
                horizontal = 24.dp,
                vertical = 12.dp,
            )
    ) {
        Spacer(Modifier.height(12.dp))
        if (item.title != null) {
            Text(
                text = item.title,
                style = AppTheme.textStyles.titleExtraBold,
                color = AppTheme.colors.primary,
            )
            Spacer(Modifier.height(24.dp))
        }
        item.meals.fastForEachIndexed { index, meal ->
            if (index > 0) Spacer(Modifier.height(24.dp))

            Row(
                modifier = Modifier.fillMaxWidth().padding(bottom = 8.dp),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                Text(
                    modifier = Modifier.weight(1f),
                    text = meal.title ?: "",
                    style = AppTheme.textStyles.title20Bold,
                    color = AppTheme.colors.text100,
                )
                if (meal.nutrition != null) {
                    AppButton(
                        minHeight = 36.dp,
                        contentPadding = PaddingValues(horizontal = 16.dp),
                        colors = AppButtonDefaults.appButtonColors(
                            contentColor = AppTheme.colors.primary,
                            containerColor = gray_2,
                        ),
                        onClick = {
                            onActionClicked(ActionModel.LogMeal(meal.nutrition))
                        },
                    ) {
                        Text(
                            text = stringResource(loco.Res.string.MEAL_PLAN_LOG_FOOD_BUTTON),
                            style = AppTheme.textStyles.secondary_14_500,
                        )
                    }
                }
            }
            if (meal.description != null) {
                Text(
                    text = meal.description,
                    style = AppTheme.textStyles.description,
                    color = AppTheme.colors.text100,
                )
            }
            meal.details.fastForEachIndexed { index, mealDetails ->
                if (index > 0 || (meal.title != null || meal.description != null)) Spacer(Modifier.height(24.dp))

                if (mealDetails.title != null) {
                    Text(
                        text = mealDetails.title,
                        style = AppTheme.textStyles.bodySemiBold,
                        color = AppTheme.colors.text100,
                    )
                }
                if (mealDetails.text != null) {
                    Text(
                        text = mealDetails.text,
                        style = AppTheme.textStyles.body,
                        color = AppTheme.colors.text100,
                    )
                }
            }
        }
    }
}